/// <reference types="@types/googlemaps" />

import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RequestService } from 'src/app/services/request.service';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { Chart, ChartTypeRegistry } from 'chart.js/auto';
import { FeatureFlagsService } from 'src/app/services/feature-flags.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

declare var google: any;

@Component({
  selector: 'app-single-plot',
  templateUrl: './single-plot.component.html',
  styleUrls: ['./single-plot.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class SinglePlotComponent implements OnInit {
  plot: any = [];
 private IP = environment.apiUrl;
 private http_type = environment.apiType;
 private baseUrl = this.http_type + '://' + this.IP;
  displayedColumns: string[] = ['plot_code', 'municipal_community', 'location', 'regional_unit', 'co_ownership', 'size', 'mapped_background', 'eco_schemes.scheme_code'];
  plotCode: any;
  langStatus: any;
  expandedPanelIndex: number = 0;
  ecoSchemes: any[] = [];
  @ViewChild('ndviChart') private ndviChart!: ElementRef;
ndviLineChart: any;

  treatmentColumns: string[] = ['lastTreatment', 'treatment', 'start_date', 'end_date'];
  treatmentData: any = [];

  irrigationColumns: string[] = ['lastIrrigation', 'irrigation_method', 'quantity', 'datetime'];
  irrigationData: any = [];

  fertilisationColumns: any[] = ['lastFertilisation', 'chemical_composition', 'amount_applied', 'datetime'];
  fertilisationData: any = [];

  sprayingColumns: any[] = ['lastSpraying', 'commercial_name', 'amount_applied', 'datetime'];
  sprayingData: any = [];

  harvestColumns: any[] = ['lastHarvest', 'cleaning_of_harvesting_equipment', 'summ', 'datetime'];
  harvestData: any = [];
polygonID!:string;
  residuesColumns: any[] = ['lastResidues', 'management_method', 'total_amount', 'datetime'];
  residuesData: any = [];

  devices: any[] = []
  sensors: any[] = [];

  plotDevices: any[] = [];
  buttonStates: { [key: string]: boolean } = {};
  spinner: boolean = false
  @ViewChild('lineCanvas') private lineCanvas!: ElementRef;
  lineChart: any;
  chart!: Chart;
  chartData: any[] = [];
  chartOptions: any = {};
  chartLineData1: any[] = [];
  chartLineData2: any[] = [];
  deviceComponents: any[] = [];
  componentsD: any[] = [];
  deviceID: any;
  lastDeviceComponents: any[] = [];
  phComponentPublic: any[] = [];
  t12ComponentPublic: any[] = [];
  sensorsButtons: boolean = false
  plotDevicesID: any[] = [];
  phFlag: boolean = false
  device_type: string = '';
  buttonStates2: { [key: string]: boolean }[] = [];
  firstDeviceID: string = ''
  plotId: any = '';

  mapViewMode: string = 'bounds';
  ndviData: any[] = [];
  currentGroundOverlay: google.maps.GroundOverlay | null = null;
  currentMap: google.maps.Map | null = null;

  lat: any;
  lon: any;
  zoom: any;
  comunityFarmer: any
  municipal: string | undefined;
  size: string | undefined;
  location: string | undefined;
  species: string | undefined;
  plotCodes: any = [];
  drawCoords: any[] = []

  public plotLocations: any[] = [];
  public plotLocationsMap: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private req: RequestService<any>,
    public translate: TranslateService,
    private datepipe: DatePipe,
    public featureFlags: FeatureFlagsService,
    private http: HttpClient) {
  }

  ngOnInit(): void {
    this.plotId = this.route.snapshot.paramMap.get('id');
    this.req.getPlot(this.plotId).subscribe((res) => {
       this.polygonID=res.polygon_id
      const isGreece = this.featureFlags.isFeatureEnabled('showGreece')
      if (isGreece) {
        this.plotDevicesID = res
        this.getPlotData();
      } else {
        this.plotDevicesID = res.devices
        this.initChart();
        this.initMapUruguay();
        this.initValues();
      }
      this.plot = res;
      this.plotDevices.push(res)
      const defaultId = this.plot.crop_info[0].crop_info_id;
      this.updateTables(defaultId);
      this.ecoSchemes.push(res)
      this.plot.size = this.plot.size.toFixed(1)
      this.plotCode = this.plot.plot_code;
    });
  }

  async getPlotData() {
    this.req.getPlot(this.plotId).subscribe((res) => {
     
      this.plotLocations.push(res)
      this.plotCodes.push(res.map_coordinates);
      this.plotLocationsMap = this.plotLocations.map((el: any) => {
        let municipalName = 'HOME.MUNICIPAL';
        let locationName = 'MAP.LOCATION';
        let sizeName = 'HOME.SIZE_PLOT';
        let speciesName = 'MAP.SPECIES';
        this.translate.get([municipalName, locationName, sizeName, speciesName])
          .subscribe(translations => {
            this.municipal = translations[municipalName];
            this.location = translations[locationName];
            this.size = translations[sizeName];
            this.species = translations[speciesName];
          });

        if (el.map_coordinates[0]) {
          return [{
            lat: el.map_coordinates[0].lat,
            lng: el.map_coordinates[0].lon,
          },
          el.crop_info.length,
          el.location,
          el.plot_code,
          el.municipal_community,
          el.size.toFixed(2),
          this.municipal,
          this.location,
          this.size,
          this.species,
          ]
        } else {
          return [{
            lat: 37.98773910747681,
            lng: 23.722049982626345,
          },
          el.crop_info.length,
          el.location,
          el.plot_code,
          el.municipal_community,
          el.size.toFixed(2),
          this.municipal,
          this.location,
          this.size,
          this.species
          ]
        }
      });
      this.initMapGreece()
    });
  }

  onMapViewModeChange(event: any) {
    this.mapViewMode = event.value;
    
    if (this.mapViewMode === 'satellite') {
      this.fetchNDVIData();
      this.updateMapView();
    } else {
      this.ndviData = [];
      this.updateMapView();
    }
  }

fetchNDVIData() {
  const polyid = '685aa384a049dece584b1794';
  const start = '1746057600';
  const end = '1750819200';
  const appid = '2fd256181cfa6a820fd980571f1b8eb6';
  
  const url = `${this.baseUrl }/api/ndvi/data/?polygon_id=${this.polygonID}`;
  
  this.http.get(url).subscribe(
    (data: any) => {
      this.ndviData = data;
      console.log('NDVI Data:', this.ndviData);
      
      // Initialize chart after data is loaded and view is ready
      setTimeout(() => {
        this.initNDVIChart();
      }, 100);
    },
    (error) => {
      console.error('Error fetching NDVI data:', error);
    }
  );
}

updateMapView() {
  if (this.currentMap && this.plotCodes.length > 0) {
    if (this.currentGroundOverlay) {
      this.currentGroundOverlay.setMap(null);
      this.currentGroundOverlay = null;
    }

    if (this.mapViewMode === 'satellite') {
      this.addSatelliteImageOverlay(this.currentMap, this.plotCodes[0]);
      
      // Initialize chart when switching to satellite mode
      setTimeout(() => {
        this.initNDVIChart();
      }, 100);
    } else {
      // Destroy chart when switching away from satellite mode
      if (this.ndviLineChart) {
        this.ndviLineChart.destroy();
        this.ndviLineChart = null;
      }
    }
  }
}
  initMapGreece(): void {
    if (this.plotCodes.length > 0) {
      this.lat = this.plotCodes[0][0].lat;
      this.lon = this.plotCodes[0][0].lon;
      this.zoom = 17;
    } else {
      this.lat = 37.98773910747681;
      this.lon = 23.722049982626345;
      this.zoom = 7;
    }
  
    const mapOptions = {
      zoom: this.zoom,
      center: { lat: this.lat, lng: this.lon },
      mapTypeId: google.maps.MapTypeId.SATELLITE,
    };
    
    const map = new google.maps.Map(
      document.getElementById("map") as HTMLElement,
      mapOptions
    );

    // Store reference to current map
    this.currentMap = map;
  
  const plotLocations: [google.maps.LatLngLiteral, number, string, any, any, any, any, any, any, any][] = this.plotLocationsMap;
  const infoWindow = new google.maps.InfoWindow();
    
    plotLocations.forEach(([position, species, location, plot_code, municipal_community, size, municipalTitle, locationTitle, sizeTitle, speciesTitle], i) => {
      const markerContent = `
        <div class="container" style="position: relative; overflow: hidden;">
          <button id="closeInfoWindow" style="position: absolute; top: 5px; right: 5px; background-color: red; color: white; border: none; padding: 3px 6px; cursor: pointer;">X</button>
          <div class="row">
              <div class="col">
                  <div class="col-3">
                      <div class="text-center" style=" font-weight: bold;">
                        ${municipalTitle}
                      </div>
                      <div class="text-center" style="font-size: 12px;">
                        ${municipal_community.split(' ')[2]}
                      </div>
                  </div>
                  <div class="col-3 pt-1">
                      <div class="text-center" style=" font-weight: bold;">
                      ${sizeTitle}
                      </div>
                      <div class="text-center" style="font-size: 12px;">
                        ${size}
                      </div>
                  </div>
              </div>
              <div class="col">
                  <div class="cageInfo" style="  
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin-bottom: -10px;">
                      <div class="imground img-fluid rounded-circle mb-3 img-thumbnail shadow-md"
                          style="border: 3px solid #06ca5b;">
                          <img id="imgcyrcle" src="../../../assets/land.png" width="45">
                      </div>
                  </div>
              </div>
              <div class="col">
                  <div class="col-3">
                      <div class="text-center" style=" font-weight: bold;">
                        ${locationTitle}
                      </div>
                      <div class="text-center" style="font-size: 12px;">
                        ${location}
                      </div>
                  </div>
                  <div class="col-3 pt-1">
                      <div class="text-center" style=" font-weight: bold;">
                      ${speciesTitle}
                      </div>
                      <div class="text-center" style="font-size: 12px;">
                        ${species}
                      </div>
                  </div>
              </div>
          </div>
        </div>
      `;

      const marker = new google.maps.Marker({
        position,
        map,
        label: `${plot_code}`,
        optimized: false,
      });

      marker.addListener("click", () => {
        infoWindow.close();
        infoWindow.setContent(markerContent);
        infoWindow.open(marker.getMap(), marker);
        google.maps.event.addListenerOnce(infoWindow, 'domready', () => {
          const closeButton = document.getElementById("closeInfoWindow");
          if (closeButton) {
            closeButton.addEventListener("click", () => {
              infoWindow.close();
            });
          }
        });
      });
    });

    this.plotCodes.forEach((element: any) => {
      this.drawCoords = element.map((el: any) => {
        return {
          lat: el.lat,
          lng: el.lon
        };
      });
    
      // Add the satellite image overlay if satellite mode is selected
      if (this.mapViewMode === 'satellite') {
        this.addSatelliteImageOverlay(map, element);
      }
    
      // Draw the polygon outline
      const drowPolygons = new google.maps.Polygon({
        paths: this.drawCoords,
        geodesic: true,
        strokeColor: "rgb(150, 231, 178)",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: this.mapViewMode === 'satellite' ? "transparent" : "#FFC107",
        fillOpacity: this.mapViewMode === 'satellite' ? 0 : 0.35,
      });
      drowPolygons.setMap(map);
    });
  } 

  initMapUruguay(): void {
    this.req.getDevices().subscribe(res => {
      const filterArray = res.filter(device => this.plotDevicesID.includes(device.attributes.uuid));
      this.devices = filterArray;
      if (this.plot && this.plot.map_coordinates && Array.isArray(this.plot.map_coordinates) && this.plot.map_coordinates.length > 0) {
        const mapCenter = {
          lat: parseFloat(this.devices[0]?.attributes.lat),
          lng: parseFloat(this.devices[0]?.attributes.lon)
        };
        const map = new google.maps.Map(document.getElementById("map")!, {
          zoom: 14,
          center: mapCenter,
          mapTypeId: google.maps.MapTypeId.SATELLITE,
          mapTypeControl: false,
          streetViewControl: false
        });

        // Store reference to current map
        this.currentMap = map;

        const pathCoordinates: google.maps.LatLngLiteral[] = this.plot.map_coordinates.map((coord: any) => ({
          lat: +coord.lat,
          lng: +coord.lon
        }));
        if (this.plot.map_coordinates.length >= 3) {
          const firstNode = this.plot.map_coordinates[0];
          pathCoordinates.push({ lat: +firstNode.lat, lng: +firstNode.lon });
        }
        const plotPolygon = new google.maps.Polygon({
          paths: pathCoordinates,
          geodesic: true,
          strokeColor: "rgb(150, 231, 178)",
          strokeOpacity: 1.0,
          fillOpacity: 0.35,
          strokeWeight: 2,
          fillColor: "#FFC107",
        });
        this.sensors = this.devices.map(device => device.attributes.components.map((component: any, index: any) => ({
          lat: parseFloat(device.attributes.lat),
          lng: parseFloat(device.attributes.lon),
          message: `
                    <div class="info-window-content" style="overflow-x: hidden; overflow-y: hidden; min-width: 280px; min-height:100px">
                        <button id="closeInfoWindow" style="position: absolute; top: 5px; right: 5px; font-weight: 600;color: #626f82;">X</button>
                        <h3 id="mapTitle" style="font-size: small;font-weight: 600;color: #626f82;margin-top: -3px;">${device.attributes.name}</h3>
                        <mat-list>
                            <div mat-line><span id="mapTitle">Status:</span> <span id="mapKeys">${device.attributes.status ? 'Active' : 'Inactive'}</span></div>
                            <mat-list-item>
                                <div mat-line><span id="mapTitle">Location:</span> <span id="mapKeys">${this.plot.location}</span></div>
                            </mat-list-item>
                            <mat-list-item>
                                <div mat-line><span id="mapTitle">Installed:</span> <span id="mapKeys">${this.datepipe.transform(device.attributes.created_at, 'medium')}</span></div>
                            </mat-list-item>
                        </mat-list>
                        <div class="p-1">
                            <div class="img-fluid rounded-rectangle img-thumbnail" style="display: flex; justify-content: center; align-items: center; font-size: x-small; text-align: center; font-weight: 600; background-color: rgb(191, 248, 211); border: 1px solid rgb(255, 255, 255); box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px; width: 51px; border-radius: 4px;">
                                <p id="sensorsTitle">${component.sensor_type}</p>
                            </div>
                        </div>
                    </div>
                `,
          color: 'rgb(150, 231, 178)',
          markerIcon: ''
        }))).flat();
        this.sensors.forEach(sensor => {
          const sensorPolyline = new google.maps.Polyline({
            path: [{ lat: sensor.lat, lng: sensor.lng }, { lat: sensor.lat, lng: sensor.lng }],
            geodesic: true,
            strokeColor: sensor.color,
            strokeOpacity: 2,
            strokeWeight: 25,
            fillColor: sensor.color,
            fillOpacity: 0.35,
          });
          const marker = new google.maps.Marker({
            position: { lat: sensor.lat, lng: sensor.lng },
            map: map,
            icon: sensor.markerIcon,
            title: 'Sensor Marker'
          });
          const infoWindow = new google.maps.InfoWindow({
            content: sensor.message,
            ariaLabel: "Uluru",
          });
          google.maps.event.addListener(infoWindow, 'domready', () => {
            document.getElementById('closeInfoWindow')?.addEventListener('click', () => {
              infoWindow.close();
            });
          });
          marker.addListener('click', () => {
            infoWindow.open(map, marker);
          });
          sensorPolyline.setMap(map);
        });
        plotPolygon.setMap(map);
      }
    });
  }

  calculateCenter(coordinates: { kombos: string | number; lat: string | number; lon: string | number }[]): google.maps.LatLngLiteral {
    let totalLat = 0;
    let totalLon = 0;
    coordinates.forEach(coord => {
      totalLat += +coord.lat;
      totalLon += +coord.lon;
    });
    const averageLat = totalLat / coordinates.length;
    const averageLon = totalLon / coordinates.length;
    return { lat: averageLat, lng: averageLon };
  }

  getColumnLabel(column: string): any {
    switch (column) {
      case 'plot_code':
        return 'HOME.CODE';
      case 'municipal_community':
        return 'HOME.MUNICIPAL';
      case 'location':
        return 'HOME.LOCATION';
      case 'regional_unit':
        return 'HOME.UNIT';
      case 'co_ownership':
        return 'HOME.OWN';
      case 'size':
        return 'HOME.ACRE';
      case 'mapped_background':
        return 'HOME.MAPPED';
      case 'eco_schemes.scheme_code':
        return 'HOME.ECO_SCHEMES';
      default:
        return '';
    }
  }

  getPropertyValue(column: string) {
    return this.plot[column];
  }

  togglePanel(index: number): void {
    if (this.expandedPanelIndex === index) {
      this.expandedPanelIndex = -1;
    } else {
      this.expandedPanelIndex = index;
    }

    const selectedCropInfoId = this.plot.crop_info[index].crop_info_id;
    this.updateTables(selectedCropInfoId)
  }

  updateTables(id: string) {
    this.req.getPlotTreatment(id).subscribe((res) => {
      if (res.length !== 0) {
        const latestTreatment = res[res.length - 1];
        this.treatmentData = [latestTreatment];
      }
    });

    this.req.getPlotIrrigation(id).subscribe((res) => {
      if (res.length !== 0) {
        const latestIrrigation = res[res.length - 1];
        this.irrigationData = [latestIrrigation];
      }
    });

    this.req.getPlotFertilisation(id).subscribe((res) => {
      if (res.length !== 0) {
        const latestFertilisation = res[res.length - 1];
        this.fertilisationData = [latestFertilisation];
      }
    });

    this.req.getPlotSpraying(id).subscribe((res) => {
      if (res.length !== 0) {
        const latestSpraying = res[res.length - 1];
        this.sprayingData = [latestSpraying];
      }
    });

    this.req.getPlotHarvest(id).subscribe((res) => {
      if (res.length !== 0) {
        const latestHarvest = res[res.length - 1];
        this.harvestData = [latestHarvest];
      }
    });

    this.req.getPlotResidues(id).subscribe((res) => {
      if (res.length !== 0) {
        const latestResidues = res[res.length - 1];
        this.residuesData = [latestResidues];
      }
    });
  }

  initChart() {
    this.lineChart = new Chart(this.lineCanvas.nativeElement, {
      type: 'line',
      data: {
        labels: [],
        datasets: [
          {
            label: 'PH',
            data: [],
            borderColor: 'rgba(73, 215, 255)',
            fill: true,
            borderWidth: 1,
            backgroundColor: 'rgba(99, 216, 248, 0.455)',
            tension: 0.4,
            pointBackgroundColor: 'white',
            pointBorderWidth: 1,
            pointBorderColor: '#1f90ec'
          },
          {
            label: 'Temperature °C',
            data: [],
            borderColor: 'rgba(205, 84, 75)',
            fill: true,
            borderWidth: 1,
            backgroundColor: 'rgba(205, 84, 75, 0.207)',
            tension: 0.4,
            pointBackgroundColor: 'white',
            pointBorderWidth: 1,
            pointBorderColor: 'rgba(205, 84, 75)'
          },
          {
            label: 'EC μS/cm',
            data: [],
            borderColor: 'rgba(67, 84, 147)',
            fill: true,
            borderWidth: 1,
            backgroundColor: 'rgba(67, 84, 147, 0.307)',
            tension: 0.4,
            pointBackgroundColor: 'white',
            pointBorderWidth: 1,
            pointBorderColor: 'rgba(67, 84, 147)'
          },
          {
            label: 'Soil Moisuture %',
            data: [],
            borderColor: 'rgba(40, 127, 71)',
            fill: true,
            borderWidth: 1,
            backgroundColor: 'rgba(40, 127, 71, 0.307)',
            tension: 0.4,
            pointBackgroundColor: 'white',
            pointBorderWidth: 1,
            pointBorderColor: 'rgba(40, 127, 71)'
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            ticks: {
              // color: 'grey',
              font: {
                size: 8,
                family: 'Arial'
              }
            },
            grid: {
              color: 'lightgray',
              lineWidth: 0.1
            }
          },
          y: {
            display: true,
            ticks: {
              color: 'grey',
              font: {
                size: 8,
                family: 'Arial'
              }
            },
            grid: {
              color: 'lightgray',
              lineWidth: 0.3
            }
          }
        }
      }
    });
  }

  initValues() {
    this.spinner = true;
    const device_type = 'PH';
    this.plotDevices.forEach(plotDevice => {
      this.firstDeviceID = plotDevice.devices[0]
      plotDevice.devices.forEach((device: any, index: any) => {
        this.buttonStates[device] = index === 0;
      });
    });
    this.req.getDevices(this.firstDeviceID).subscribe(res => {
      if (res) {
        this.spinner = false
        this.sensorsButtons = true
        this.phFlag = true
      }
      this.lastDeviceComponents = [...this.phComponentPublic, ...this.t12ComponentPublic];
      this.lineChart.update();
      this.componentsD.push(res)
      this.initSensor()
    });
  }

  initSensor() {
    this.sensorsButtons = true;
    this.device_type = 'PH';
    this.req.getDevicesOverall(this.firstDeviceID, this.device_type).subscribe(res => {
      if (res.length > 0) {
        this.spinner = false;
        const lastObject = res.slice(-1)[0];
        this.phComponentPublic = [lastObject];
        this.lastDeviceComponents = [...this.phComponentPublic, ...this.t12ComponentPublic];
        res.forEach(el => {
          this.lineChart.data.labels.push(this.datepipe.transform(el.attributes.measurement_time, 'dd/MM/yyyy HH:mm'));
          this.lineChart.data.datasets[0].data.push(el.attributes.renke[0].value);
        });
      }
      this.lineChart.update();
      this.buttonStates2 = this.componentsD.map(group => {
        let groupButtonStates: { [key: string]: boolean } = {};
        group.attributes.components.forEach((button: any) => {
          if (button.sensor_type === 'PH' && this.device_type === 'PH') {
            groupButtonStates[button.sensor_type] = true;
            button.isOn = true;
          } else {
            groupButtonStates[button.sensor_type] = false;
            button.isOn = false;
          }
        });
        if (!Object.values(groupButtonStates).includes(true)) {
          const firstButton = group.attributes.components[0];
          groupButtonStates[firstButton.sensor_type] = true;
          firstButton.isOn = true;
        }
        return groupButtonStates;
      });
    });
  }

  chooseDevice(event: any, button: any) {
    this.device_type = ''
    this.buttonStates2 = [{ ph: false, t12: false }]
    this.spinner = true
    this.buttonStates[button] = event.source._checked;
    this.lineChart.data.datasets[0].data = []
    this.deviceID = button
    this.componentsD = [];
    this.lineChart.data.labels = [];
    this.phComponentPublic = [];
    this.lineChart.data.datasets[0].data = [];

    if (this.buttonStates[button]) {
      this.req.getDevices(button).subscribe(res => {
        if (res) {
          this.spinner = false
          this.sensorsButtons = true
        }
        this.lastDeviceComponents = [...this.phComponentPublic, ...this.t12ComponentPublic];
        this.lineChart.update();
        this.componentsD.push(res)
      });
    } else {
      this.spinner = false
      this.componentsD = [];
      this.lineChart.data.labels = [];
      this.phComponentPublic = [];
      this.lineChart.data.datasets[0].data = [];
      this.lineChart.update();
    }

    Object.keys(this.buttonStates).forEach(key => {
      if (key !== button) {
        this.buttonStates[key] = false;
      }
    });
    this.componentsD = [];
    this.lastDeviceComponents = [];
    this.componentsD = [];
    this.lineChart.data.labels = [];
    this.phComponentPublic = [];
    this.lineChart.data.datasets[0].data = [];
  }

  chooseSensor(event: any, button: any, groupIndex: number, sens: any) {
    this.deviceID = sens.id
    this.deviceComponents = [];
    button.isOn = event.source._checked;
    this.buttonStates2[groupIndex][button.sensor_type] = button.isOn;

    if (!this.phComponentPublic) {
      this.phComponentPublic = [];
    }
    if (!this.t12ComponentPublic) {
      this.t12ComponentPublic = [];
    }

    // Toggle data for PH sensors
    if (event.source._checked && button.sensor_type.includes("PH")) {
      this.spinner = true
      this.lineChart.data.labels = [];
      this.device_type = 'PH';
      this.lineChart.options.scales.y.ticks.min = 0;
      this.lineChart.options.scales.y.ticks.max = 10;
      this.req.getDevicesOverall(this.deviceID, this.device_type).subscribe(res => {
        if (res.length > 0) {
          this.spinner = false
          const lastObject = res.slice(-1)[0]
          this.phComponentPublic = [lastObject];
          this.lastDeviceComponents = [...this.phComponentPublic, ...this.t12ComponentPublic];
          res.forEach(el => {
            this.lineChart.data.labels.push(this.datepipe.transform(el.attributes.measurement_time, 'dd/MM/yyyy HH:mm'));
            this.lineChart.data.datasets[0].data.push(el.attributes.renke[0].value);
          })
        }
        this.lineChart.update();
      });
    } else if (!event.source._checked && button.sensor_type.includes("PH")) {
      this.phComponentPublic = [];
      this.lineChart.data.datasets[0].data = [];
      this.lastDeviceComponents = [...this.phComponentPublic, ...this.t12ComponentPublic];
      this.lineChart.update();
    }

    // Toggle data for T12 sensors
    if (event.source._checked && button.sensor_type.includes("T12")) {
      this.spinner = true
      this.lineChart.data.labels = [];
      const device_type = 'T12';
      this.req.getDevicesOverall(this.deviceID, device_type).subscribe(res => {
        if (res.length > 0) {
          this.spinner = false
          const lastObject = res.slice(-1)[0]
          this.t12ComponentPublic = [lastObject].map(item => {
            const newTerros12 = item.attributes.terros_12.filter((sensor: any) =>
              ["temperature", "bulk_electrical_conductivity", "transformed_mineral_soil"].includes(sensor.name)
            ).map((sensor: any) => {
              let newName, newUnit, newValue;
              switch (sensor.name) {
                case "temperature":
                  newName = "Temperature";
                  newUnit = sensor.unit;
                  newValue = sensor.value;
                  break;
                case "bulk_electrical_conductivity":
                  newName = "EC";
                  newUnit = sensor.unit;
                  newValue = sensor.value;
                  break;
                case "transformed_mineral_soil":
                  newName = "Soil_Moisture";
                  newUnit = "%";
                  newValue = (sensor.value * 100).toFixed(2);
                  break;
              }
              return {
                name: newName,
                unit: newUnit,
                value: newValue
              };
            });
            return {
              ...item,
              attributes: {
                ...item.attributes,
                terros_12: newTerros12
              }
            };
          });
          this.lastDeviceComponents = [...this.phComponentPublic, ...this.t12ComponentPublic];
          res.forEach((item: any) => {
            this.lineChart.data.labels.push(this.datepipe.transform(item.attributes.measurement_time, 'dd/MM/yyyy HH:mm'));
            this.lineChart.data.datasets[1].data.push(item.attributes.terros_12[1].value);
            this.lineChart.data.datasets[2].data.push(item.attributes.terros_12[2].value);
            this.lineChart.data.datasets[3].data.push(item.attributes.terros_12[3].value * 100);
          })
        }
        this.lineChart.update();
      });
    } else if (!event.source._checked && button.sensor_type.includes("T12")) {
      this.t12ComponentPublic = [];
      this.lineChart.data.datasets[1].data = [];
      this.lineChart.data.datasets[2].data = [];
      this.lineChart.data.datasets[3].data = [];
      this.lastDeviceComponents = [...this.phComponentPublic, ...this.t12ComponentPublic];
      this.lineChart.update();
    }
  }

addSatelliteImageOverlay(map: google.maps.Map, coordinates: any[]): void {
  // Calculate the bounds of your plot coordinates
  const bounds = this.calculateBounds(coordinates);
  
  // Your satellite image URL
  const imageUrl = `${this.baseUrl }/api/ndvi/image/?polygon_id=${this.polygonID}`;
  
  // Create the ground overlay
    this.currentGroundOverlay = new google.maps.GroundOverlay(
    imageUrl,
    bounds,
    {
      opacity: 0.8, // Adjust transparency (0-1)
      clickable: false
    }
  );
  
  // Add the overlay to the map
    if (this.currentGroundOverlay) {
      this.currentGroundOverlay.setMap(map);
    }
  }

  // Helper method to calculate bounds from coordinates
  calculateBounds(coordinates: any[]): google.maps.LatLngBounds {
    const bounds = new google.maps.LatLngBounds();
    
    coordinates.forEach(coord => {
      bounds.extend(new google.maps.LatLng(coord.lat, coord.lon));
    });
    
    return bounds;
  }

// Alternative method if you want more control over the image positioning
addCustomSatelliteOverlay(map: google.maps.Map, coordinates: any[]): void {
  // Calculate precise bounds
  let minLat = coordinates[0].lat;
  let maxLat = coordinates[0].lat;
  let minLng = coordinates[0].lon;
  let maxLng = coordinates[0].lon;
  
  coordinates.forEach(coord => {
    minLat = Math.min(minLat, coord.lat);
    maxLat = Math.max(maxLat, coord.lat);
    minLng = Math.min(minLng, coord.lon);
    maxLng = Math.max(maxLng, coord.lon);
  });
  
  // Create bounds with some padding
  const padding = 0.001; // Adjust as needed
  const bounds = new google.maps.LatLngBounds(
    new google.maps.LatLng(minLat - padding, minLng - padding),
    new google.maps.LatLng(maxLat + padding, maxLng + padding)
  );
  
  const imageUrl = `${this.baseUrl }/api/ndvi/image/?polygon_id=${this.polygonID}`;
  
  const groundOverlay = new google.maps.GroundOverlay(
    imageUrl,
    bounds,
    {
      opacity: 0.75,
      clickable: false
    }
  );
  
  if (groundOverlay) {
    groundOverlay.setMap(map);
  }
}

initNDVIChart() {
  if (this.ndviChart && this.ndviData.length > 0) {
    // Sort data by date (oldest first)
    const sortedData = [...this.ndviData].sort((a, b) => a.dt - b.dt);
    
    // Prepare data
    const labels = sortedData.map(entry => 
      new Date(entry.dt * 1000).toLocaleDateString('el-GR', { 
        day: '2-digit', 
        month: '2-digit', 
        year: '2-digit' 
      })
    );
    
    const minValues = sortedData.map(entry => entry.data.min);
    const maxValues = sortedData.map(entry => entry.data.max);
    const meanValues = sortedData.map(entry => entry.data.mean);

    this.ndviLineChart = new Chart(this.ndviChart.nativeElement, {
      type: 'line',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Mean NDVI',
            data: meanValues,
            borderColor: '#2563eb',
            backgroundColor: 'rgba(37, 99, 235, 0.1)',
            fill: false,
            borderWidth: 3,
            tension: 0.4,
            pointBackgroundColor: '#2563eb',
            pointBorderColor: '#ffffff',
            pointBorderWidth: 2,
            pointRadius: 5
          },
          {
            label: 'Max NDVI',
            data: maxValues,
            borderColor: '#16a34a',
            backgroundColor: 'rgba(22, 163, 74, 0.1)',
            fill: false,
            borderWidth: 2,
            tension: 0.4,
            pointBackgroundColor: '#16a34a',
            pointBorderColor: '#ffffff',
            pointBorderWidth: 2,
            pointRadius: 4
          },
          {
            label: 'Min NDVI',
            data: minValues,
            borderColor: '#dc2626',
            backgroundColor: 'rgba(220, 38, 38, 0.1)',
            fill: false,
            borderWidth: 2,
            tension: 0.4,
            pointBackgroundColor: '#dc2626',
            pointBorderColor: '#ffffff',
            pointBorderWidth: 2,
            pointRadius: 4
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: true,
            text: 'NDVI Values Trend Analysis',
            font: {
              size: 16,
              weight: 'bold'
            }
          },
          legend: {
            display: true,
            position: 'top',
            labels: {
              usePointStyle: true,
              padding: 20
            }
          },
          tooltip: {
            mode: 'index',
            intersect: false,
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            titleColor: '#ffffff',
            bodyColor: '#ffffff',
            callbacks: {
              label: function(context: any) {
                return `${context.dataset.label}: ${context.parsed.y.toFixed(3)}`;
              }
            }
          }
        },
        scales: {
          x: {
            display: true,
            title: {
              display: true,
              text: 'Date',
              font: {
                size: 14,
                weight: 'bold'
              }
            },
            grid: {
              color: 'rgba(0, 0, 0, 0.1)'
            }
          },
          y: {
            display: true,
            title: {
              display: true,
              text: 'NDVI Value',
              font: {
                size: 14,
                weight: 'bold'
              }
            },
            min: -0.2,
            max: 1.0,
            grid: {
              color: 'rgba(0, 0, 0, 0.1)'
            },
            ticks: {
              callback: function(value: any) {
                return value.toFixed(1);
              }
            }
          }
        },
        interaction: {
          mode: 'nearest',
          axis: 'x',
          intersect: false
        }
      }
    });
  }
}
}